import * as types from "./types";
import {
  isFetchingHighlightsSummary,
  isLoadedHighlightsSummary
} from "./selectors";
import JigsawAPI from "../../services/jigsaw";

const fetchHighlightsRequest = () => ({
  type: types.GET_HIGHLIGHT_SUMMARY_REQUEST
});

const fetchHighlightsSuccess = data => ({
  type: types.GET_HIGHLIGHT_SUMMARY_SUCCESS,
  data
});

const fetchHighlightsError = error => ({
  type: types.GET_HIGHLIGHT_SUMMARY_ERROR,
  error
});

const shouldFetchHighlightsSummary = state => {
  return (
    !isLoadedHighlightsSummary(state) && !isFetchingHighlightsSummary(state)
  );
};

export const fetchHighlightsSummary = (force = false) => async (
  dispatch,
  getState
) => {
  const state = getState();
  if (force || shouldFetchHighlightsSummary(state)) {
    dispatch(fetchHighlightsRequest());
    return JigsawAPI.Book.getHighlightSummary()
      .then(({ highlights }) => dispatch(fetchHighlightsSuccess(highlights)))
      .catch(error => dispatch(fetchHighlightsError(error)));
  }
};
